import { CONTENT } from "@/content";

export default function Marquee() {
  const items = [...CONTENT.marquee, ...CONTENT.marquee];
  return (
    <div data-testid="marquee" className="relative border-y border-white/5 py-6 md:py-8 overflow-hidden select-none">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {items.map((word, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display font-bold uppercase tracking-tight text-2xl md:text-4xl text-[#f5f3ef]/75 px-6 md:px-10">
                  {word}
                </span>
                <span className="w-8 md:w-12 h-px bg-[#38bdf8]/50" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
